// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3glDd","content":"styles_content__1suA7","tableWrap":"styles_tableWrap__ICs3I"};